/**
 * @generated SignedSource<<5b652e9a60a9e0017387a3397bb138b8>>
 * @relayHash cba0e0c039d1e8cd94ce48d9acad8fca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d3cdff7258a89cfa088caa39ca2ba9afc9ec65b65f1e76b2f2ead528186dee49

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceCommentsPanelSorting = "MOST_RECENT" | "PAGE_ORDER" | "%future added value";
export type FeedType = "DIRECT" | "FOLLOWING" | "POPULAR" | "%future added value";
export type HomeWidgetState = "COLLAPSED" | "EXPANDED" | "%future added value";
export type MissionControlFeatureDiscoverySuggestion = "SPACE_MANAGER" | "SPACE_REPORTS" | "USER_ACCESS" | "%future added value";
export type MissionControlMetricSuggestion = "DEACTIVATED_PAGE_OWNERS" | "INACTIVE_PAGES" | "UNASSIGNED_GUESTS" | "%future added value";
export type PageCardInPageTreeHoverPreference = "NO_OPTION_SELECTED" | "NO_SHOW_PAGECARD" | "SHOW_PAGECARD" | "%future added value";
export type PagesDisplayPersistenceOption = "CARDS" | "COMPACT_LIST" | "LIST" | "%future added value";
export type RecentFilter = "ALL" | "COLLABORATED_ON" | "CREATED" | "WORKED_ON" | "%future added value";
export type UserSettingsQuery$variables = {
  isNotLicensed: boolean;
};
export type UserSettingsQuery$data = {
  readonly featureDiscovery: ReadonlyArray<{
    readonly date: string | null | undefined;
    readonly featureKey: string | null | undefined;
    readonly pluginKey: string | null | undefined;
    readonly userKey: string | null | undefined;
  } | null | undefined> | null | undefined;
  readonly userPreferences?: {
    readonly __typename: "UserPreferences";
    readonly commentsPanelSorting: ConfluenceCommentsPanelSorting;
    readonly confluenceEditorSettings: {
      readonly toolbarDockingInitialPosition: string | null | undefined;
    } | null | undefined;
    readonly favouriteTemplateEntityIds: ReadonlyArray<string | null | undefined>;
    readonly feedRecommendedUserSettingsDismissTimestamp: string;
    readonly feedTab: string | null | undefined;
    readonly feedType: FeedType | null | undefined;
    readonly globalPageCardAppearancePreference: PagesDisplayPersistenceOption;
    readonly homePagesDisplayView: PagesDisplayPersistenceOption;
    readonly homeWidgets: ReadonlyArray<{
      readonly __typename: "HomeWidget";
      readonly id: string;
      readonly state: HomeWidgetState;
    }>;
    readonly isHomeOnboardingDismissed: boolean;
    readonly missionControlFeatureDiscoverySuggestions: ReadonlyArray<{
      readonly dismissalDateTime: string | null | undefined;
      readonly suggestion: MissionControlFeatureDiscoverySuggestion;
    } | null | undefined>;
    readonly missionControlMetricSuggestions: ReadonlyArray<{
      readonly dismissalDateTime: string | null | undefined;
      readonly suggestion: MissionControlMetricSuggestion;
      readonly value: number | null | undefined;
    } | null | undefined>;
    readonly missionControlOverview: ReadonlyArray<string | null | undefined>;
    readonly recentFilter: RecentFilter;
    readonly shouldShowCardOnPageTreeHover: PageCardInPageTreeHoverPreference;
    readonly theme: string;
    readonly userSpacesNotifiedOfExternalCollab: ReadonlyArray<string | null | undefined>;
    readonly watchMyOwnContent: boolean | null | undefined;
  } | null | undefined;
};
export type UserSettingsQuery = {
  response: UserSettingsQuery$data;
  variables: UserSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isNotLicensed"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "suggestion"
},
v2 = {
  "kind": "ScalarField",
  "name": "dismissalDateTime"
},
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = [
  {
    "condition": "isNotLicensed",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "concreteType": "UserPreferences",
        "kind": "LinkedField",
        "name": "userPreferences",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "shouldShowCardOnPageTreeHover"
          },
          {
            "kind": "ScalarField",
            "name": "feedRecommendedUserSettingsDismissTimestamp"
          },
          {
            "kind": "ScalarField",
            "name": "userSpacesNotifiedOfExternalCollab"
          },
          {
            "kind": "ScalarField",
            "name": "favouriteTemplateEntityIds"
          },
          {
            "kind": "ScalarField",
            "name": "homePagesDisplayView"
          },
          {
            "kind": "ScalarField",
            "name": "feedType"
          },
          {
            "kind": "ScalarField",
            "name": "feedTab"
          },
          {
            "kind": "ScalarField",
            "name": "recentFilter"
          },
          {
            "kind": "ScalarField",
            "name": "missionControlOverview"
          },
          {
            "concreteType": "MissionControlMetricSuggestionState",
            "kind": "LinkedField",
            "name": "missionControlMetricSuggestions",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "name": "value"
              },
              (v2/*: any*/)
            ]
          },
          {
            "concreteType": "ConfluenceEditorSettings",
            "kind": "LinkedField",
            "name": "confluenceEditorSettings",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "toolbarDockingInitialPosition"
              }
            ]
          },
          {
            "concreteType": "MissionControlFeatureDiscoverySuggestionState",
            "kind": "LinkedField",
            "name": "missionControlFeatureDiscoverySuggestions",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "name": "globalPageCardAppearancePreference"
          },
          {
            "concreteType": "HomeWidget",
            "kind": "LinkedField",
            "name": "homeWidgets",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "state"
              },
              (v3/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "name": "isHomeOnboardingDismissed"
          },
          {
            "kind": "ScalarField",
            "name": "theme"
          },
          {
            "kind": "ScalarField",
            "name": "watchMyOwnContent"
          },
          {
            "kind": "ScalarField",
            "name": "commentsPanelSorting"
          },
          (v3/*: any*/)
        ]
      }
    ]
  },
  {
    "concreteType": "DiscoveredFeature",
    "kind": "LinkedField",
    "name": "featureDiscovery",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "pluginKey"
      },
      {
        "kind": "ScalarField",
        "name": "featureKey"
      },
      {
        "kind": "ScalarField",
        "name": "userKey"
      },
      {
        "kind": "ScalarField",
        "name": "date"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "UserSettingsQuery",
    "selections": (v4/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserSettingsQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "cba0e0c039d1e8cd94ce48d9acad8fca",
    "id": "d3cdff7258a89cfa088caa39ca2ba9afc9ec65b65f1e76b2f2ead528186dee49",
    "metadata": {},
    "name": "UserSettingsQuery",
    "operationKind": "query",
    "text": "query UserSettingsQuery($isNotLicensed:Boolean!){userPreferences@skip(if:$isNotLicensed){shouldShowCardOnPageTreeHover,feedRecommendedUserSettingsDismissTimestamp,userSpacesNotifiedOfExternalCollab,favouriteTemplateEntityIds,homePagesDisplayView,feedType,feedTab,recentFilter,missionControlOverview,missionControlMetricSuggestions{suggestion,value,dismissalDateTime},confluenceEditorSettings{toolbarDockingInitialPosition},missionControlFeatureDiscoverySuggestions{suggestion,dismissalDateTime},globalPageCardAppearancePreference,homeWidgets{id,state,__typename},isHomeOnboardingDismissed,theme,watchMyOwnContent,commentsPanelSorting,__typename},featureDiscovery{pluginKey,featureKey,userKey,date}}"
  }
};
})();

(node as any).hash = "441b6789e4c3a0f20f0c78d76c5b57cd";

export default node;
